import { render, staticRenderFns } from "./addSection.vue?vue&type=template&id=00045ef3&scoped=true&"
import script from "./addSection.vue?vue&type=script&lang=js&"
export * from "./addSection.vue?vue&type=script&lang=js&"
import style0 from "./addSection.vue?vue&type=style&index=0&id=00045ef3&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00045ef3",
  null
  
)

export default component.exports